webpackJsonp([114276838955818,60335399758886],{

/***/ 105:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Eloy Pineda","subtitle":"personal website"}}},"layoutContext":{}}

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(240);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(105);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LogoModule = __webpack_require__(327);
	
	var _LogoModule2 = _interopRequireDefault(_LogoModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'svg',
	    {
	      'aria-labelledby': 'eloy-logo',
	      className: _LogoModule2.default.e,
	      role: 'img',
	      viewBox: '0 0 228 228',
	      xmlns: 'http://www.w3.org/2000/svg' },
	    _react2.default.createElement(
	      'title',
	      { id: 'eloy-logo' },
	      'Eloy Pineda logo'
	    ),
	    _react2.default.createElement('path', {
	      d: 'M114 228C51 228 0 177 0 114 0 51 51 0 114 0 177 0 228 51 228 114 228 177 177 228 114 228ZM171 95L171 57C171 46.5 162.5 38 152 38L76 38C65.5 38 57 46.5 57 57L57 171C57 181.5 65.5 190 76 190L133 190C143.5 190 152 181.5 152 171 152 160.5 143.5 152 133 152L114 152C103.5 152 95 143.5 95 133 95 122.5 103.5 114 114 114L152 114C162.5 114 171 105.5 171 95ZM95 76C95 65.5 103.5 57 114 57 124.5 57 133 65.5 133 76 133 86.5 124.5 95 114 95 103.5 95 95 86.5 95 76Z',
	      fill: '#009499' })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 327:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"e":"src-components-Logo----Logo-module---e---P9emv"};

/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Logo = __webpack_require__(238);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Logo).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Logo = __webpack_require__(239);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var children = _ref.children,
	      data = _ref.data,
	      location = _ref.location;
	  return _react2.default.createElement(
	    'div',
	    { style: { margin: '1rem auto', padding: '0 1rem', width: '320px' } },
	    _react2.default.createElement(_Logo2.default, { style: { width: '50%' } }),
	    _react2.default.createElement(
	      'h1',
	      null,
	      data.site.siteMetadata.title,
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'small',
	        null,
	        data.site.siteMetadata.subtitle
	      )
	    ),
	    children()
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-04fd54c0d580d12681ef.js